<template lang="pug">
  betList(betType="FGLG")
</template>

<script>
import betList from "@/views/stock/_betList.vue";

export default {
  components: {
    betList
  }
};
</script>